export default {
  name: 'custom_number_field',
  component_path: 'modules/procedures/blocks/BlockInputNumber'
}